import { LitElement, html, svg } from 'lit';

export class IconFilter24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>To horisontale skyveknapper over hverandre</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1.5 6H16M8 18h14.5M20 6h2.5M1.5 18H4"></path><circle cx="18" cy="6" r="2" stroke="currentColor" stroke-width="1.5"></circle><circle cx="6" cy="18" r="2" stroke="currentColor" stroke-width="1.5"></circle></svg>`; }
}
if (!customElements.get('f-icon-filter24', IconFilter24)) {
  customElements.define('f-icon-filter24', IconFilter24);
}